// extracted by mini-css-extract-plugin
export default {"deleteButton":"exercise-edit_deleteButton__JiFlL"};